import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateCompanyVerification } from "@/lib/api/admin-company.api"
import { useAuthStore } from "@/store/auth.store"

export function useUpdateCompanyVerification() {
  const queryClient = useQueryClient()
  const { accessToken } = useAuthStore()

  return useMutation({
    mutationFn: async ({ id, status }: { id: string; status: string }) => {
      if (!accessToken) throw new Error("No access token")
      const response = await updateCompanyVerification(id, status, accessToken)
      if (!response.success) throw new Error(response.message)
      return response.data
    },
    onSuccess: (_, variables) => {
      // Invalidate the company details query to refresh the status
      queryClient.invalidateQueries({ queryKey: ["admin-company-details"] })
      // Invalidate the list of verifications
      queryClient.invalidateQueries({ queryKey: ["admin-company-verifications"] })
    },
  })
}
